import type { FC } from 'react';
import { StyledButton, StyledLinkButton, StyledLoading } from './button.styles';

interface CommonProps {
  text: string;
  type: 'contained' | 'outline';
  color?: 'primary' | 'secondary';
  disabled?: boolean;
  loading?: boolean;
  size?: 'small' | 'medium' | 'large';
}

interface LinkProps extends CommonProps {
  to: string;
}

interface ButtonProps extends CommonProps {
  onClick: () => void;
}

type Props = LinkProps | ButtonProps;

export const Button: FC<Props> = (props) => {
  const {
    color = 'primary',
    disabled,
    loading,
    size = 'large',
    text,
    type = 'contained',
  } = props;

  if ('to' in props) {
    return (
      <StyledLinkButton
        $color={color}
        $disabled={disabled}
        $size={size}
        $type={type}
        title={text}
        to={props.to}
      >
        {text}
      </StyledLinkButton>
    );
  }

  return (
    <StyledButton
      $color={color}
      $disabled={disabled}
      $size={size}
      $type={type}
      onClick={disabled ? undefined : props.onClick}
    >
      {loading ? <StyledLoading /> : null}
      <span>{text}</span>
    </StyledButton>
  );
};
